enum NavigationDirectionEnum {
    Back,
    Forward,
    Current
}

export default NavigationDirectionEnum;
